import type { FC } from "react";
import type { ButtonSelectOption as ButtonSelectOptionType } from "../types";
import styles from "./styles.module.scss";

type Props = {
  option: ButtonSelectOptionType;
};

export const ButtonSelectOption: FC<Props> = ({ option }) => {
  return (
    <div className={styles["option-wrapper"]}>
      {option?.icon && option.icon}
      <span>{option.label}</span>
    </div>
  );
};
